export enum CAROUSEL_TYPE {
  CASE_STUDY = "case",
  PLAN = "plan",
}
